/**
 * Product Timeline – Cumulative hover activation
 * When hovering step N, steps 0..N all become active (black).
 * When mouse leaves the timeline, everything goes back to grey.
 */
(function () {
  'use strict';

  var steps = document.querySelectorAll('[data-tl-step]');
  if (!steps.length) return;

  function activateUpTo(index) {
    steps.forEach(function (step, i) {
      if (i <= index) {
        step.classList.add('is-active');
      } else {
        step.classList.remove('is-active');
      }
    });
  }

  function deactivateAll() {
    steps.forEach(function (step) {
      step.classList.remove('is-active');
    });
  }

  /* Attach hover listeners to each step */
  steps.forEach(function (step, i) {
    step.addEventListener('mouseenter', function () {
      activateUpTo(i);
    });
  });

  /* When mouse leaves the whole timeline track, reset */
  var track = document.querySelector('.eki-timeline__track');
  if (track) {
    track.addEventListener('mouseleave', function () {
      deactivateAll();
    });
  }
})();
